export default "/images/ic-logout.svg?e350d649e977e4352f09f0ec88ba7fc7";